import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { useIsMobile } from "@/hooks/use-mobile";
import { useState } from "react";
import { UserRow } from "./UserRow";
import { UserCard } from "./UserCard";
import { DeleteUserDialog } from "./DeleteUserDialog";
import { Profile } from "@/hooks/profile/types";
import { PaymentStatus } from "@/hooks/admin/useUserPayments";
import { DebtInfo } from "@/hooks/admin/useMemberDebts";

interface UsersTableProps {
  users: Profile[];
  isLoading: boolean;
  onBanUser: (userId: string, banned: boolean) => void;
  onDeleteUser: (userId: string) => void;
  onRoleChange: (userId: string, newRole: string) => void;
  currentUser?: Profile | null;
  paymentStatusMap?: Map<string, PaymentStatus>;
  actsAsRecepcionista?: boolean;
  isMastergym?: boolean;
  debtsMap?: Map<string, DebtInfo>;
}

export const UsersTable = ({
  users,
  isLoading,
  onBanUser,
  onDeleteUser,
  onRoleChange,
  currentUser,
  paymentStatusMap,
  actsAsRecepcionista = false,
  isMastergym = false,
  debtsMap,
}: UsersTableProps) => {
  const isMobile = useIsMobile();
  const [userToDelete, setUserToDelete] = useState<Profile | null>(null);

  if (isLoading) {
    return (
      <div className="text-center py-4">
        <p>Cargando usuarios...</p>
      </div>
    );
  }

  if (isMobile) {
    return (
      <>
        <div className="flex flex-col gap-3">
          {users?.map((user) => (
            <UserCard
              key={user.id}
              user={{ ...user, birthdate: user.birthdate || null }}
              onBanUser={onBanUser}
              onDeleteClick={setUserToDelete}
              onRoleChange={onRoleChange}
              currentUser={currentUser}
              paymentStatus={paymentStatusMap?.get(user.id)}
              actsAsRecepcionista={actsAsRecepcionista}
              isMastergym={isMastergym}
              debtInfo={debtsMap?.get(user.id)}
            />
          ))}
        </div>
        <DeleteUserDialog
          user={userToDelete}
          onClose={() => setUserToDelete(null)}
          onConfirm={(userId) => {
            onDeleteUser(userId);
            setUserToDelete(null);
          }}
          isRemoveFromGym={true}
        />
      </>
    );
  }

  return (
    <div className="h-full overflow-hidden">
      <Table className="w-full table-fixed">
        <TableHeader className="sticky top-0 bg-background z-10">
          <TableRow>
            <TableHead>Usuario</TableHead>
            <TableHead>Rol</TableHead>
            <TableHead>Estado</TableHead>
            <TableHead>Cuota</TableHead>
            <TableHead className="text-right">Acciones</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {users?.map((user, index) => (
            <UserRow
              key={user.id}
              user={{ ...user, birthdate: user.birthdate || null }}
              index={index}
              isMobile={false}
              onBanUser={onBanUser}
              onDeleteClick={setUserToDelete}
              onRoleChange={onRoleChange}
              currentUser={currentUser}
              paymentStatus={paymentStatusMap?.get(user.id)}
              actsAsRecepcionista={actsAsRecepcionista}
              isMastergym={isMastergym}
              debtInfo={debtsMap?.get(user.id)}
            />
          ))}
        </TableBody>
      </Table>

      <DeleteUserDialog
        user={userToDelete}
        onClose={() => setUserToDelete(null)}
        onConfirm={(userId) => {
          onDeleteUser(userId);
          setUserToDelete(null);
        }}
        isRemoveFromGym={true}
      />
    </div>
  );
};
